import Head from "next/head";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import styles from "../../styles/pages/conteudos-gratuitos.module.scss";
import Header from "../../components/Header";
import FloatLinks from "../../components/FloatLinks";
import { freeContentItems } from "../../components/_conteudosGratuitos/FreeContentCard/free-content-utils";
import FreeContentCard from "../../components/_conteudosGratuitos/FreeContentCard";
import { GetStaticProps } from "next";
import { blogApi } from "../../services/axios";
import { BlogService } from "../../services/blog-service";

type FreeContentProps = {
  blogPosts: Array<any>;
};

export default function FreeContent({ blogPosts }: FreeContentProps) {
  useEffect(() => {
    AOS.init({
      disable: "mobile",
      duration: 700,
      easing: "ease-out-cubic",
      once: true,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Head>
        <title>Kenzie Academy Brasil - Conteúdos Gratuitos</title>
        <meta
          name="description"
          content="Conteúdos gratuitos para você iniciar na programação"
        />
        <meta
          name="twitter:title"
          content="Conteúdos gratuitos para você iniciar na programação"
        />
        <meta
          name="twitter:description"
          content="Conteúdos gratuitos para você iniciar na programação"
        />
        <meta
          property="og:title"
          content="Conteúdos gratuitos para você iniciar na programação"
        />
        <link
          rel="canonical"
          href="https://kenzie.com.br/conteudos-gratuitos"
        />
      </Head>

      <Header />

      <main className={styles.bg}>
        <section className={styles.hero}>
          <div className="container">
            <div className={styles.content} data-aos="fade-right">
              <h1>conteúdos gratuitos</h1>
              <p>
                Nesta página, você pode encontrar diversos tipos de material
                para complementar o seu aprendizado na área de programação!
                Separados por categorias, é possível encontrar e-books,
                infográficos, vídeos e artigos que ajudam você a compreender
                conceitos da profissão e do mercado de desenvolvimento web.
              </p>
            </div>
          </div>
        </section>

        <section>
          <div className="container" data-aos="fade-left">
            <ul className={styles.freeContentList}>
              {freeContentItems.map((ebook, index) => (
                <FreeContentCard key={index} content={ebook} blog={blogPosts} />
              ))}
            </ul>
          </div>
        </section>
      </main>
      <FloatLinks />
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  const blogService = new BlogService(blogApi);

  const dayInSeconds = 60 * 60 * 24;

  const slugs = [
    "area-de-ti",
    "como-aprender-a-programar-2",
    "full-stack-o-que-e",
  ];

  const blogPosts = await Promise.all(
    slugs.map(async (slug) => await blogService.getPostsBySlug(slug))
  );

  return {
    props: { blogPosts },
    revalidate: dayInSeconds,
  };
};
